import { TenantInfo, UserSettings } from './../action-creators/auth.actions.creators';
import { tokenType } from "../../containers/authv2/TokenType";
import { ActionType } from "../action-types";
import { Action } from "../actions";
interface AuthRepoState {
  loggedUser: {};
  loggedUserRoles: any[];
  accountActiveStep: number;
  authState: boolean;
  apps: string[];
  token: tokenType | null
  encodedToken: string;
  userSettings: UserSettings | undefined
  accountInfo: TenantInfo | undefined
}

const initialState = {
  loggedUser: {},
  loggedUserRoles: [],
  accountActiveStep: 1,
  authState: true,
  apps: [],
  userSettings: undefined,
  token: null,
  encodedToken: "",
  accountInfo: undefined
};

const AuthReducer = (
  state: AuthRepoState = initialState,
  action: Action
): AuthRepoState => {
  switch (action.type) {
    case ActionType.SET_USER:
      return {
        ...state,
        loggedUser: action.payload,
      };
    case ActionType.SET_USER_ROLE:
      return {
        ...state,
        loggedUserRoles: action.payload,
      };
    case ActionType.SET_ACCOUNT_ACTIVE_STATE:
      return {
        ...state,
        accountActiveStep: action.payload,
      };
    case ActionType.SET_AUTH_STATE:
      return {
        ...state,
        authState: action.payload,
      };
    case ActionType.SET_APPSLIST:
      return {
        ...state,
        apps: action.payload,
      };
    case ActionType.SET_TOKEN:
      return {
        ...state,
        token: action.payload,
      };
    case ActionType.SET_ENCODED_TOKEN:
      return {
        ...state,
        encodedToken: action.payload,
      };
    case ActionType.SET_USERSETTINGS:
      return {
        ...state,
        userSettings: action.payload,
      };
    case ActionType.SET_ACCOUNTINFO:
      return {
        ...state,
        accountInfo: action.payload,
      };
    default:
      return state;
  }
};
export default AuthReducer;
